export const toTitlecase = string =>
  string?.replace(/(^|\s)\S/g, function (t) {
    return t.toUpperCase();
  });

export const removeDecimal = string => {
  string = string?.toString().split('.')[0];
  return string;
};
